import React from 'react';
import { Tag } from 'antd';

/* 화면테스트 문서 탭 공용 — 타입·색·유틸 */

export interface PlanRow {
  id: number; doc_no: string; version: string; title: string;
  purpose: string; scope: string; strategy: string; environment: string;
  schedule_desc: string; criteria_note: string; out_of_scope: string; risk_note: string;
  criteria_pass_rate: number; criteria_coverage: number; targets: string;
  author: string; reviewer: string; approver: string;
  status: 'draft' | 'approved' | 'archived';
  approved_at: string | null; baseline_at: string | null; has_baseline: boolean;
  case_count: number | null; created_by: string; created_at: string | null; updated_at: string | null;
}

export interface CaseSpecRow {
  id: number; plan_id: number; case_no: string;
  site: string; screen_code: string; screen_name: string; screen_path: string; group_name: string;
  check_code: string; check_name: string;
  precondition: string; procedure: string; expected: string;
  priority: '상' | '중' | '하'; exec_type: 'auto' | 'manual'; note: string;
  is_custom: boolean; sort_order: number; updated_by: string; updated_at: string | null;
}

export interface DatasetRow {
  id: number; plan_id: number | null; code: string; name: string; site: string;
  data_type: string; value: string; source: string; is_sensitive: boolean; note: string;
  created_by: string; updated_at: string | null;
}

export interface DefectRow {
  id: number; defect_no: string; defect_key: string;
  site: string; screen_code: string; screen_name: string; screen_path: string;
  check_code: string; check_name: string;
  title: string; severity: string; status: string; source: string;
  detail: string; last_detail: string; cause: string; action: string; fix_commit: string;
  assignee: string; occurrence_count: number;
  first_run_id: number | null; last_run_id: number | null;
  first_seen_at: string | null; last_seen_at: string | null;
  last_passed_run_id: number | null; last_passed_at: string | null;
  resolved_at: string | null; resolved_by: string; created_at: string | null;
}

export const PLAN_STATUS: Record<string, { label: string; color: string; bg: string }> = {
  draft: { label: '작성 중', color: '#475569', bg: '#e2e8f0' },
  approved: { label: '승인', color: '#047857', bg: '#d1fae5' },
  archived: { label: '보관', color: '#7c2d12', bg: '#fed7aa' },
};

/* 상태색만으로 구분하지 않는다 — 라벨 문자를 항상 함께 노출한다 */
export const DEFECT_STATUS: Record<string, { color: string; bg: string }> = {
  '신규': { color: '#b91c1c', bg: '#fee2e2' },
  '조치중': { color: '#1d4ed8', bg: '#dbeafe' },
  '조치완료': { color: '#047857', bg: '#d1fae5' },
  '재발': { color: '#7c2d12', bg: '#fed7aa' },
  '보류': { color: '#a16207', bg: '#fef3c7' },
  '기각': { color: '#475569', bg: '#e2e8f0' },
};

export const DEFECT_SEVERITY: Record<string, string> = {
  '치명': '#7f1d1d', '중대': '#dc2626', '보통': '#f59e0b', '경미': '#94a3b8',
};

export const SITE_META: Record<string, { label: string; color: string }> = {
  lab: { label: 'lab', color: '#4f46e5' },
  partner: { label: 'partner', color: '#f59e0b' },
};

export const SiteTag: React.FC<{ site: string }> = ({ site }) => (
  <Tag style={{ margin: 0, color: SITE_META[site]?.color, borderColor: SITE_META[site]?.color }}>
    {SITE_META[site]?.label || site}
  </Tag>
);

/** 권한 헤더가 붙은 엔드포인트라 <a href> 로는 못 받는다 — blob 으로 받아 저장한다 */
export const downloadBlob = (res: any, fallback: string) => {
  const cd = res.headers?.['content-disposition'] || '';
  const m = /filename="?([^";]+)"?/.exec(cd);
  const name = m ? decodeURIComponent(m[1]) : fallback;
  const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
  const a = document.createElement('a');
  a.href = url; a.download = name;
  document.body.appendChild(a); a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 4000);
};
